export default {"src":"/_next/static/media/about-us-icon.b8677861.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};